import { useState, useEffect } from "react";
import { checksumAddress } from "viem";

const useWalletConnection = ({ isConnected, setUserDelegators }) => {
    const [isAccountsChanged, setIsAccountsChanged] = useState(false);
    const [changedAddress, setChangedAddress] = useState(null);

    useEffect(() => {
        const handleAccountsChanged = async (accounts) => {
            if (accounts && accounts.length > 0 && isConnected) {
                window.location.reload();
                setIsAccountsChanged(true);
                setChangedAddress(checksumAddress(accounts[0]));
            } else {
                setIsAccountsChanged(false);
                setChangedAddress(null);
            }
        };

        if (window.ethereum) {
            // Adding the event listener to listen for account changes
            window.ethereum.on("accountsChanged", handleAccountsChanged);

            // Check if there's already an account when the component mounts
            window.ethereum.request({ method: "eth_accounts" })
                .then((accounts) => {
                    if (accounts && accounts.length > 0 && isConnected) {
                        setChangedAddress(checksumAddress(accounts[0]));
                    }
                })
                .catch((err) => console.error("Error checking accounts:", err));
        } else {
            console.warn("Ethereum provider not found");
        }

        // Cleanup the event listener when the component unmounts
        return () => {
            if (window.ethereum) {
                window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
            }
        };
    }, [isConnected]); // Add isConnected to the dependency array to track changes

    return {
        isAccountsChanged,
        changedAddress,
        setIsAccountsChanged,
    };
};

export default useWalletConnection;
